// extracted by mini-css-extract-plugin
export var contact = "footer-module--contact--01fe0";
export var copyright = "footer-module--copyright--43e5e";
export var footer = "footer-module--footer--33bb1";
export var logo = "footer-module--logo--bf967";
export var seperator = "footer-module--seperator--905c7";
export var twitter = "footer-module--twitter--fdb84";